export default {"src":"/_next/static/media/permanent-support.fa252604.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};